import { useMemo } from 'react';
import { ENV } from '../utils/env.utils';
import { useCheckPermission } from './useCheckPermission';
import { useNavigationLinkMatched } from './useNavigationLinkMatched';

export function useIsLeoPermitted() {
  const { matchedLink } = useNavigationLinkMatched();

  const hasReportsAnalysis = useCheckPermission('reports');
  const hasFlowAnalysis = useCheckPermission('flow');

  return useMemo(() => {
    if (matchedLink?.disabledLeo) {
      return false;
    }

    const hasRequiredPermissions = hasReportsAnalysis || hasFlowAnalysis;

    return ENV?.LEO_ENABLED && hasRequiredPermissions;
  }, [matchedLink, hasReportsAnalysis, hasFlowAnalysis, ENV?.LEO_ENABLED]);
}
